(function($) {
    'use strict';
    var ContentExpander = function(el) {
        this.$el = $(el);
        this.settings = $.extend(
            {
                startExpanded: false,
                collapsedHeightElement: '> :eq(2)',
                target: '',
                container: '.container'
            },
            this.settings,
            this.$el.data()
        );
        this.$container = this.$el.closest(this.settings.container);
        if (!this.$container.size()) {
            this.$container = $('body');
        }
        this.$target = this.$container.find(this.settings.target);
        this.$collapsedHeightElement = this.$target.find(
            this.settings.collapsedHeightElement
        );
        this.$icon = this.$el.find('i');
        this.init();
    };
    ContentExpander.prototype = {
        init: function() {
            var that = this;
            that.$target.css('overflow', 'hidden');
            that.bindEvents();
            that.updateHeight();
        },
        bindEvents: function() {
            var that = this;
            that.$el.on('click', function() {
                if (that.$target.hasClass('expanded')) {
                    that.$icon.removeClass('icon-arrow-up').addClass('icon-arrow-down');
                    that.collapse();
                } else {
                    that.$icon.removeClass('icon-arrow-down').addClass('icon-arrow-up');
                    that.expand();
                }

                return false;
            });
            $(window).resize(function() {
                that.updateHeight();
            });
        },
        expand: function() {
            var that = this,
                expandedHeight;
            that.$target.addClass('expanded');
            that.$target.css('height', 'auto');
            expandedHeight = that.$target.height();
            that.$target.css('height', that.getCollapsedHeight());
            that.$target.animate({ height: expandedHeight }, 'slow');
        },
        collapse: function() {
            var that = this;
            that.$target.removeClass('expanded');
            that.$target.animate({ height: that.getCollapsedHeight() }, 'slow');

            $('html, body').animate(
                {
                    scrollTop: that.$target.offset().top - 140
                },
                500
            );
        },
        updateHeight: function() {
            var that = this;
            if (!that.$target.hasClass('expanded')) {
                that.$target.css('height', that.getCollapsedHeight());
            }
        },
        getCollapsedHeight: function() {
            return (
                this.$collapsedHeightElement.position().top +
                this.$collapsedHeightElement.outerHeight(true)
            );
        }
    };
    $.fn.contentExpander = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('contentExpander');
            if (!data) {
                $this.data(
                    'contentExpander',
                    (data = new ContentExpander(this, options))
                );
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };
    $.fn.contentExpander.Constructor = ContentExpander;
})(jQuery);
